import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { Box, Typography } from "@mui/material";
import { NotificationProps } from "src/types/NotificationProps";
import notifyStyles from "./Notify.module.css";

const NotifyWarning = ({ header, children }: NotificationProps) => {
  return (
    <Box sx={{ display: "inline" }}>
      <Box className={notifyStyles.notifyHeader}>
        <WarningAmberIcon className={notifyStyles.warnIcon} />
        <Typography
          variant="h4"
          className={notifyStyles.warnIcon}
        >
          {header}
        </Typography>
      </Box>
      <Box className={notifyStyles.childrenBox}>{children}</Box>
    </Box>
  );
};

export default NotifyWarning;
